// store/actions/msgActions.js
export default {
    async sendTextMsg({ commit, dispatch, state }, { fromGuid, targetGuid, text }) {
        if (!state.isLogin || !state.imInstans) return;

        const contentType = 1;
        const time = Date.now();
        const tempGuid = `temp_${time}_${Math.random().toString(36).substr(2, 9)}`;

        const tempMsg = {
            guid: tempGuid,
            fromGuid,
            targetGuid,
            data: text,
            contentType,
            time,
            readStatus: 1
        };

        commit('ADD_MESSAGE_TO_SESSION', { sessionId: targetGuid, message: tempMsg }, { root: true });

        try {
            const guid = await state.imInstans.newGuid();
            const result = await state.imInstans.sendTextMsg(guid, fromGuid, targetGuid, text, 1);

            if (result?.code === 200) {
                const finalMsg = { guid, fromGuid, targetGuid, data: text, contentType, time, readStatus: 1 };
                await dispatch('replaceTempMessage', { sessionId: targetGuid, tempGuid, finalMsg });
                try {
                    const EventBus = require('@/common/EventBus').EventBus;
                    EventBus.$emit('new-message-received', { sessionId: targetGuid, message: finalMsg });
                } catch (e) {
                    // 静默失败，不影响主流程
                    console.warn('[IM] 触发新消息事件失败:', e);
                }
            } else {
                throw new Error('发送失败');
            }
        } catch (error) {
            console.error('发送文本消息失败:', error);
            await dispatch('markMessageFailed', { sessionId: targetGuid, msgGuid: tempGuid });
        }
    },

    async replaceTempMessage({ commit, state }, { sessionId, tempGuid, finalMsg }) {
        const sessionMap = state.sessionMap instanceof Map ? new Map(state.sessionMap) : new Map();
        const session = sessionMap.get(sessionId);
        if (!session?.messages) return;

        const tempIndex = session.messages.findIndex(m => m?.guid === tempGuid);
        if (tempIndex !== -1) {
            session.messages[tempIndex] = finalMsg;
        } else {
            const exists = session.messages.some(m => m?.guid === finalMsg.guid);
            if (!exists) session.messages.push(finalMsg);
        }

        session.messages.sort((a, b) => (a.time || 0) - (b.time || 0));
        session.lastMsg = session.messages[session.messages.length - 1];
        session.lastMsgTime = session.lastMsg.time;

        sessionMap.set(sessionId, session);
        commit('SET_SESSION_MAP', sessionMap, { root: true });
    },

    async sendImageMsg({ dispatch, state }, { fromGuid, targetGuid, msgData }) {
        if (!state.isLogin || !state.imInstans) return;

        const contentType = 2;
        const time = Date.now();
        const tempGuid = `temp_img_${time}_${Math.random().toString(36).substr(2, 9)}`;

        await dispatch('appendTempSessionMsg', { fromGuid, targetGuid, msgData, contentType, tempGuid, time });

        try {
            const guid = await state.imInstans.newGuid();
            const msgDataStr = JSON.stringify(msgData);
            const result = await state.imInstans.sendImageMsg(guid, fromGuid, targetGuid, msgDataStr, 1);

            if (result?.code === 200) {
                const finalMsg = { guid, fromGuid, targetGuid, data: msgData, contentType, time, readStatus: 1 };
                await dispatch('replaceTempMessage', { sessionId: targetGuid, tempGuid, finalMsg });
                try {
                    const EventBus = require('@/common/EventBus').EventBus;
                    EventBus.$emit('new-message-received', { sessionId: targetGuid, message: finalMsg });
                } catch (e) {
                    // 静默失败，不影响主流程
                    console.warn('[IM] 触发新消息事件失败:', e);
                }
                return finalMsg;
            } else {
                throw new Error('发送失败');
            }
        } catch (error) {
            console.error('Send image message error:', error);
            await dispatch('markMessageFailed', { sessionId: targetGuid, msgGuid: tempGuid });
            throw error;
        }
    },

    async sendHouseCardDirectly({ dispatch, state }, { fromGuid, targetGuid, houseInfo, tradeType }) {
        if (!state.isLogin || !state.imInstans || !targetGuid || !fromGuid) {
            console.error('[IM] IM未登录或缺少必要参数');
            return false;
        }

        const houseData = {
            guid: houseInfo.guid || houseInfo.houseGuid || '',
            coverImage: houseInfo.coverImage || houseInfo.coverImg || houseInfo.cover || '',
            title: houseInfo.estateName || houseInfo.title || '房源',
            room: houseInfo.room || 0,
            hall: houseInfo.hall || 0,
            buildingArea: houseInfo.buildingArea || houseInfo.area || 0,
            price: houseInfo.price || 0,
            rentPrice: houseInfo.rentPrice || 0,
            unitPrice: houseInfo.unitPrice || 0,
            tradeType: tradeType || 2,
        };

        const contentType = 4;
        const time = Date.now();
        const tempGuid = `temp_house_${time}_${Math.random().toString(36).substr(2, 9)}`;

        await dispatch('appendTempSessionMsg', { fromGuid, targetGuid, msgData: houseData, contentType, tempGuid, time });

        try {
            const guid = await state.imInstans.newGuid();
            const houseDataStr = JSON.stringify(houseData);

            let result = null;
            if (typeof state.imInstans.sendHouseMsg === 'function') {
                result = await state.imInstans.sendHouseMsg(guid, fromGuid, targetGuid, houseDataStr, 1);
            } else if (typeof state.imInstans.sendCustomMsg === 'function') {
                result = await state.imInstans.sendCustomMsg(guid, fromGuid, targetGuid, houseDataStr, 4, 1);
            } else {
                const wrappedData = JSON.stringify({ type: 'house_card', contentType: 4, data: houseData });
                result = await state.imInstans.sendTextMsg(guid, fromGuid, targetGuid, wrappedData, 1);
            }

            if (result?.code === 200) {
                const finalMsg = { guid, fromGuid, targetGuid, data: houseData, contentType, time, readStatus: 1 };
                await dispatch('replaceTempMessage', { sessionId: targetGuid, tempGuid, finalMsg });
                try {
                    const EventBus = require('@/common/EventBus').EventBus;
                    EventBus.$emit('new-message-received', { sessionId: targetGuid, message: finalMsg });
                    EventBus.$emit('refrenshSessionList', true);
                } catch (e) {
                    // 静默失败，不影响主流程
                    console.warn('[IM] 触发刷新事件失败:', e);
                }
                return true;
            } else {
                throw new Error('发送房源消息失败');
            }
        } catch (error) {
            console.error('[IM] 发送房源卡片失败:', error);
            await dispatch('markMessageFailed', { sessionId: targetGuid, msgGuid: tempGuid });
            return false;
        }
    },

    async appendTempSessionMsg({ commit }, { fromGuid, targetGuid, msgData, contentType, tempGuid, time }) {
        commit('ADD_MESSAGE_TO_SESSION', {
            sessionId: targetGuid,
            message: { guid: tempGuid, fromGuid, targetGuid, data: msgData, contentType, time, readStatus: 1 }
        }, { root: true });
    },

    async markMessageFailed({ commit, state }, { sessionId, msgGuid }) {
        const sessionMap = state.sessionMap instanceof Map ? new Map(state.sessionMap) : new Map();
        const session = sessionMap.get(sessionId);
        if (!session?.messages) return;

        const msgIndex = session.messages.findIndex(m => m?.guid === msgGuid);
        if (msgIndex !== -1) {
            session.messages[msgIndex] = { ...session.messages[msgIndex], status: 'failed' };
            sessionMap.set(sessionId, session);
            commit('SET_SESSION_MAP', sessionMap, { root: true });
        }
    },

    async markMessagesAsRead({ commit, state }, { fromGuid, targetGuid }) {
        if (!state.isLogin || !state.imInstans) return false;

        try {
            if (typeof state.imInstans.clearUnread === 'function') {
                await state.imInstans.clearUnread(fromGuid, [targetGuid]);
            }

            const session = state.sessionMap.get(targetGuid);
            if (session?.messages) {
                session.messages = session.messages.map(msg => {
                    if (msg?.fromGuid === fromGuid && msg.readStatus !== 1) {
                        return { ...msg, readStatus: 1 };
                    }
                    return msg;
                });
            }

            commit('im/UPDATE_UNREAD_COUNT', { sessionId: targetGuid, unreadCount: 0 }, { root: true });
            commit('im/FORCE_REFRESH_CONVERSATIONS', null, { root: true });

            try {
                const EventBus = require('@/common/EventBus').EventBus;
                EventBus.$emit('unread-messages-updated', { timestamp: Date.now(), sessionId: targetGuid });
            } catch (e) {
                // 静默失败，不影响主流程
                console.warn('[IM] 触发未读更新事件失败:', e);
            }
            return true;
        } catch (error) {
            console.error('标记消息已读失败:', error);
            return false;
        }
    },
};